import { render, staticRenderFns } from "./singleCustomer.vue?vue&type=template&id=c16888b6&scoped=true&"
import script from "./singleCustomer.vue?vue&type=script&lang=js&"
export * from "./singleCustomer.vue?vue&type=script&lang=js&"
import style0 from "./singleCustomer.vue?vue&type=style&index=0&id=c16888b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16888b6",
  null
  
)

export default component.exports